'use strict';

var _mobiledocError = require('./mobiledoc-error');

exports['default'] = function (message, conditional) {
  if (!conditional) {
    throw new _mobiledocError['default'](message);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-kit/dist/commonjs/mobiledoc-kit/utils/assert.js
// module id = 8
// module chunks = 0